export default function (corPadrao) {
    let vector = hexaDecode(corPadrao);
    let luminosidade =
        (vector[0] * 299 + vector[1] * 587 + vector[2] * 114) / 1000;
    if (luminosidade > 128) {
        vector[0] = parseInt(vector[0] - vector[0] * 0.5);
        vector[1] = parseInt(vector[1] - vector[1] * 0.5);
        vector[2] = parseInt(vector[2] - vector[2] * 0.5);
        return hexaEncode(vector);
    } else {
        return corPadrao
    }
}

function hexaEncode(vector) {
    let cor = "#";
    let novoNumero = null;
    vector.forEach((numero) => {
        if (numero.toString(16).length == 1) {
            novoNumero = "0" + numero.toString(16);
            cor = cor + novoNumero;
        } else cor = cor + numero.toString(16);
    });
    return cor;
}

function hexaDecode(hex) {
    let red = hex?.substring(1, 3);
    let green = hex?.substring(3, 5);
    let blue = hex?.substring(5, 7);

    let r = parseInt(red, 16);
    let g = parseInt(green, 16);
    let b = parseInt(blue, 16);

    let hexa = [r, g, b];
    return hexa;
}